<kendo-expansionpanel [title]="'Required Carrier Services'"
                      [subtitle]="''"
                      [expanded]="true">
    <kendo-grid #carrierServiceGrid
                [data]="gridData"
                [pageSize]="gridState.take"
                [skip]="gridState.skip"
                [sort]="gridState.sort"
                [filter]="gridState.filter"
                [pageable]="true"
                [sortable]="true"
                [filterable]="true"
                [resizable]="true"
                [autoSize]="true"
                (dataStateChange)="dataStateChange($event)">
        <kendo-grid-column title="Required?">
            <ng-template kendoGridCellTemplate let-dataItem>
                <input type="checkbox" [(ngModel)]="dataItem.isChecked" [checked]="dataItem.isChecked" (change)="saveServiceMaps(dataItem)" style="margin:5px;transform: scale(1.5);" [disabled]="!canEdit()" />
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="abbreviation" title="Service Abbrev"></kendo-grid-column>
        <kendo-grid-column field="description" title="Service Description"></kendo-grid-column>
        <kendo-grid-column title="Override">
            <ng-template kendoGridCellTemplate let-dataItem>
                <div [innerHTML]="getOverrideInfo(dataItem.carrierServiceID)"></div>
            </ng-template>
        </kendo-grid-column>
    </kendo-grid>
    <!--<kendo-grid #carrierServiceGrid
                [data]="gridData"
                [pageSize]="10"
                [pageable]="true"
                [sortable]="true"
                [filterable]="true"
                [resizable]="true"
                [autoSize]="true">
        <kendo-grid-column title="Action">
            <ng-template kendoGridCellTemplate let-dataItem>
                <input type="checkbox" [(ngModel)]="dataItem.carrierServiceID" [checked]="dataItem.isChecked" (change)="saveServiceMaps(dataItem)" style="margin:5px;transform: scale(1.5);" />
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="carrierServiceAbbr" title="Service Abbrev"></kendo-grid-column>
        <kendo-grid-column field="carrierServiceDescription" title="Service Description"></kendo-grid-column>
        <kendo-grid-column field="overrideEmployeeName" title="Override By"></kendo-grid-column>
        <kendo-grid-column field="overrideManagerEmployeeName" title="Override Mgr"></kendo-grid-column>
        <kendo-grid-column field="overrideNote" title="Override Note"></kendo-grid-column>
        <kendo-grid-column field="overrideDate" title="Override Date">
            <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.overrideDate | date: 'M/dd/yyyy'}}
            </ng-template>
        </kendo-grid-column>
    </kendo-grid>-->
    <!--<div style="height:300px;overflow:scroll;">
        <table>
            <tr *ngFor="let item of carrierServiceList">
                <td><input type="checkbox" [(ngModel)]="item.isChecked" [checked]="item.isChecked" (change)="saveServiceMaps(item)" style="margin:5px;transform: scale(1.5);" /></td>
                <td (click)="setServiceMap(item)">{{item.abbreviation}}</td>
                <td (click)="setServiceMap(item)">{{item.description}}</td>
            </tr>
        </table>
    </div>-->
</kendo-expansionpanel>
